import { Mediator, app, payload } from "modular-openscriptjs";
import { eParse, inform, empty, acknowledge } from "../helpers";
import { STRINGS, api, uc, gc } from "../declarations";
import { $e } from "../ojs.events";

export class DeliveryRequest extends Mediator {
    $$deliveryRequest = {
        needs: {
            estimateFee: (ed, event) => this.estimateFee(ed, event),
            storage: (ed, event) => this.storeRequest(ed, event),
        },
    };

    async estimateFee(ed, event) {
        let data = eParse(ed);
        let params = data.message.getAll();

        let res = await api.get(
            "delivery-requests/customer/estimate-fee",
            params,
            { silent: true }
        );

        if (res && res.data) {
            this.broadcast($e.deliveryRequest.has.estimatedFee, payload(res.data, data.meta));
        } else {
            this.broadcast($e.deliveryRequest.has.estimateError, payload({
                message: "Failed to calculate delivery fee."
            }, data.meta));
        }
    }

    async storeRequest(ed, event) {
        let data = eParse(ed);
        let params = data.message.getAll();

        let res = await api.post("delivery-requests", params);

        if (!res) {
            this.broadcast($e.deliveryRequest.has.storageError, ed);
            return;
        }

        let order = res.data.order;
        if (order && !order.is_pay_on_delivery && order.status === "pending") {
            this.broadcast(
                $e.order.needs.payment,
                payload({
                    orderId: order.id,
                    amount: order.total_delivery_price,
                    currency: order.currency || "KES",
                })
            );
        } else {
            acknowledge({
                title: "Thank You!",
                message: "We have received your request. Our deliverer will arrive soon for pickup.",
                close_text: "Perfect"
            });
        }

        this.broadcast($e.deliveryRequest.stored, ed);
    }
}
